import React from 'react'
import AffiliateTemplate from 'src/components/template/affiliate'
export default (props) => <AffiliateTemplate />
